import type { ModelsPlatformStatsResponse } from '@/api/generated-api'
import { createQueryHook } from '@/shared/api/createQueryHook'
import { loadApiClient } from '@/shared/api/lazyClient'

export const enum StatsQueryKeys {
  PLATFORM = 'platform_stats'
}

const fetchPlatformStats = async (): Promise<ModelsPlatformStatsResponse> => {
  const api = await loadApiClient()
  return api.v2StatsPlatformList()
}

const usePlatformStatsFactory = createQueryHook<
  ModelsPlatformStatsResponse | undefined,
  ModelsPlatformStatsResponse
>({
  getQueryKey: () => [StatsQueryKeys.PLATFORM],
  queryFn: () => fetchPlatformStats(),
  getOptions: initialData => ({
    staleTime: 5 * 60 * 1000,
    refetchOnMount: false,
    ...(initialData ? { initialData } : {})
  })
})

export function usePlatformStats(initialData?: ModelsPlatformStatsResponse) {
  return usePlatformStatsFactory(initialData)
}
